import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function FeatureSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">全品类尺码对照</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            覆盖鞋子、服装、童装等全品类，亚洲五码一站式对照查询
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="bg-background-50 border border-background-200/60 rounded-lg p-6 cursor-pointer transition-all hover:border-primary-300 hover:bg-background-100/50 group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{cat.name}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}